import {Form} from 'antd'
import meta from './metaFm.mjs'
import Select from './SelectFm.jsx'

export const FormItemFm = props => (
    <Form.Item
        label={meta.name}
        name="fm"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemFms = props => (
    <Form.Item
        label={meta.name}
        name="fms"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
